export default {
  "interview_yk": {
    "first": {
      "name": "Y.Kさん",
      "job": "ERP事業部",
      "year": "2007",
      "title": "SOLPACの価値をさらに上げることに貢献したい",
      "visual": "yk-main_01.jpg",
      "subtitle": "システムの設計から導入、保守・運用まで幅広い業務を担当しています。",
      "text": "食品製造メーカーで基幹業務システム（ERP）の刷新から携わり、システム切替え後はシステムパートナーとして業務サポートとシステム改善などの保守を担当しています。 ERPシステムの中でも主に生産・在庫管理領域の担当で、工場の方々の業務と直接関わってくる領域です。使用する情報を収集・整理して、スムーズにマスター化、生産が滞らないようにすることが求められています。また、最近は担当領域が広がり、月ごとの製造原価算出のサポートもミッションとなっています。どちらも即時性が高く、お客様企業の動向や業務背景などを理解していることが必要なので、常に情報収集のアンテナを張るように意識しています。 また、一般的にお客様企業にとっては既存システムの保守だけではなく、将来に向けた投資を考えていく必要があるので、定型のシステム保守費用を減らしていけるように業務やシステムの改善をしています。その一環として直近では、人員削減や登録ミス・エラーを減らすことを目的とした、レシピのマスター作成を半自動化する開発も自ら担当しています。"
    },
    "second": {
      "visual": "yk-sub_01.jpg",
      "subtitle_1": "ソルパックでの仕事の喜びや、やりがいを教えてください。",
      "text_1": "会社も超えて色々な方と仕事ができることです。私の担当ではパートナー企業の方と仕事をすることがとても多いです。そんな中、先輩や同期とチームを組んだことがあるパートナー企業の方から「ソルパックには優秀な人が多い」との評価を聞くこともあります。自分にとっても嬉しく、またお互い切磋琢磨して仕事を続けていくための活力にもなります。大きな会社ではないですが、評価してくれるパートナーと仕事ができることはありがたいことだと思っています。",
      "subtitle_2": "失敗談があれば教えてください。",
      "text_2": "失敗はたくさんありますが、お客様の信頼を得ることができずに、大事な年次作業を遅延させてしまった事があります。 システム開発のみでなく、お客様と直接会話するようになった初めの頃は、話をうまく伝えることが出来ずに苦労しました。お客様の業務内容を理解できておらず、お客様が困っている背景や意図をくみ取れなかったこと、理解しづらいシステム用語を多用して会話をしてしまったことが原因でした。そんな状態で打ち合わせを行ったため、すでに予定が差し迫っていた作業に関して進め方の認識が噛み合わず、本番のゴーサインがもらえず、結果的に1か月ほど作業を延期することとなってしまいました。",
      "subtitle_3": "ソルパックの特徴は？",
      "text_3": "ソルパックは元気な会社です。年間通じて社内の全体会議やキックオフイベント、海外研修や、フットサル大会などのイベントがあり、現場に出ている社員も集まりいつも盛り上がっています。特に若手社員がグイグイ引っ張って盛り上げてくれています。そんな環境ですので、風通しもよく、チャレンジングにイキイキと仕事ができる会社だと感じています。",
      "subtitle_4": "これから仕事で挑戦したいことは何ですか？",
      "text_4": "ソルパックの価値をさらに上げることに貢献したいです。より質の高いサービスを提供し、ソルパックの価値を上げることに貢献したいと思っています。自分自身がさらに成長して魅力ある人物となれるように、そして、まわりを巻き込んで会社全体を盛り上げられるように、”チーム・ソルパック”としてさらに高いレベルを目指していきたいと思います。",
    },
    "formParam": ""
  },
  "interview_mw": {
    "first": {
      "name": "M.Wさん",
      "job": "ERP事業部",
      "year": "2009",
      "title": "SOLPACの一員という意識をもって働いています",
      "visual": "mw-main_01.jpg",
      "subtitle": "さまざまな経験を生かして人材紹介営業を担当しています。",
      "text": "入社後、開発や管理部門などさまざまな業務を経て、現在は人材紹介営業を担当しています。お客様が必要としているスキルを持つ開発者を探して紹介するのがメインの仕事です。 学生時代や入社当時は、営業の仕事は絶対に自分には無理だと思っていましたが、今思うと営業である今が一番楽しく仕事が出来ている気がしています。"
    },
    "second": {
      "visual": "mw-sub_01.jpg",
      "subtitle_1": "仕事のやりがい、また失敗談について聞かせてください。",
      "text_1": "営業なのでお客様にお叱りを受けることもありますが、人材のご紹介がうまくいき成約に至ったとき、お客様から「ありがとう」や「助かった！今後もよろしく」と言われると、この仕事について良かったととても嬉しくなります。 逆に失敗したなと思うこともあります。契約条件の調整に時間がかかってしまい、成約するはずだった技術者が他社で契約していまい白紙になったこともあります。その時は営業としてのとっさの判断力の重要性について考えさせられました。",
      "subtitle_2": "学生時代はどんな学生でしたか？",
      "text_2": "いい意味でたくさん遊んでいました。色々な経験を楽しみました。中でも居酒屋のアルバイトを４年間続けたおかげで、今の営業としてのコミュニケーション力が身に着いたと今では思っています。 経営学部ということもあり、大学では会社経営のロールプレイングなど仲間と共に悩みながら取り組んたことも大きな経験でした。授業や卒論でPCを使用することもあり、その時に手に職を付けたいと考えたのがきっかけで、IT業界で就職活動をしました。その中で、社長の会社に対する熱い思いに感動してソルパックに入社することになりました。",
      "subtitle_3": "これからの野望は何ですか？",
      "text_3": "ソルパックに入社した時に掲げていた目標が「何でもいいからNo.１になる」だったので、常に上を目指して取り組んでいます。営業である今は１社でも多くお客様からお仕事をもらえるようにと日々積み重ねていって、営業でNo.１と言われるようになりたいと思っています。 ２児の母でもあるので、子供たちに憧れてもらえるような、たくましく働くお母さんになりたいとも思っています。",
      "subtitle_4": "オフタイムは何をしていますか？",
      "text_4": "家族で公園めぐりをしてリフレッシュしています。家ではディズニーのDVDや音楽をかけて、娘のミュージカルごっこに癒されています。",
    },
    "formParam": ""
  },
  "interview_kn2": {
    "first": {
      "name": "K.Nさん",
      "job": "サービスマネジメント事業部",
      "year": "2008",
      "title": "前職の経験を活かしつつ<br />さらなるスキルアップを",
      "visual": "kn2-main.jpg",
      "subtitle": "SEで経験を積んだのち、ソリューション営業を担当しています。",
      "text": "入社して5年ほどはSEとしてシステムの導入等に関するいくつかの現場を経験しました。現在はお客様の抱える問題を解決するための様々なソリューションを提案する、ソリューション営業を担当しています。取引中のお客様の新たな課題に対するソリューション提案や、新規のお客様への製品の提案などがメインの業務です。SEでの経験を生かしつつ、SEとはまた異なる視点でお客様と接することができるのが今の楽しみです。"
    },
    "second": {
      "visual": "kn2-sub.jpg",
      "subtitle_1": "ソルパックでの仕事のやりがいや喜びを教えてください。",
      "text_1": "お客様からの「ありがとう」がやりがいです。新規のサービスを導入する際にはなかなか思うように事が進まず、体力的にも精神的にも疲弊していまうのですが、無事にサービスインした後にお客様から直接、「ありがとう」の言葉をいただけた時は何よりも最高に気持ちが良い瞬間です。",
      "subtitle_2": "失敗談があれば教えてください。",
      "text_2": "失敗談は多過ぎて選べません（笑）。ただ、その数多くの失敗から学んだことは、“常に２歩、３歩先を見据えて行動する”ということです。目の前の事だけにとらわれていると、効率も上がらない上に、不足の事態が発生した時に対応が遅くなったり、対応しきれなかったりしていまいます。常に先の事を考えながら行動することによって、事前にミスを発見できたり、そのリカバリも早期に行うことができます。実際、まだまだ目の前の仕事に振り回されることもありまるのですが、常にこれを意識して行動することを心掛けています。 失敗することは恐いし嫌なものですが、そこから学べることが非常に多いので、どんどん失敗して、自分の力にしていくことが大切だと思えるようになりました。",
      "subtitle_3": "ソルパックを選んだ理由は？",
      "text_3": "環境と人柄で決めました。それほど深く考えずにソルパックの会社説明会へ参加したのですが、その際に社長や先輩社員の皆様のお話を聞くうちに、この会社なら自分にとって良い環境で、素敵な先輩方と共に成長できると感じたのでソルパックに決めました。",
      "subtitle_4": "オフタイムは何をしていますか？ or プライベートでの趣味は何ですか？",
      "text_4": "ソルパックではサッカー好きの方が多く、平日にもフットサルをやる機会があるくらい頻繁にみんなで集まってフットサルを楽しんでいます。また、最近家族が増えたので子供と遊ぶことが多いです。",
    },
    "formParam": ""
  },
  "interview_kn1": {
    "first": {
      "name": "K.Nさん",
      "job": "コンサルティング事業部",
      "year": "2017",
      "title": "毎日スキルアップしている自分を感じています",
      "visual": "kn-main_01.jpg",
      "subtitle": "現在は社内のBPOセンターで先輩にOJTを受けながら３つの業務を担当しています。",
      "text": "１つ目は外資系マーケティング会社の市場顧客度満足調査の分析レポート作成です。販売データを担当しているのですが、このレポートはセールスマンの方の成績などに直結するものになので、とても細かなチェックをしながら作成しております。 ２つ目は、外資系企業のEDIサーバー監視業務です。EDIとはElectronic Data Interchangeの略称で、標準化された規約に基づき、企業間で電子化された注文書や請求書などをやりとりしていることを指します。監視では受注が正しく行われているか伝票が届いているか、時間通りに発注されているかを確認しています。不具合が生じている場合には、すぐに修正を行います。この作業をすることによって受発注が問題なく行われます。 ３つ目は医薬品販売に関するデータ作成です。クライアントから要望されたデータを色々なツールを使い作成しています。いずれも、ソルパックのBPOセンターでは主に外資系のクライアントが多く、お客様の大切なデータを取り扱っています。"
    },
    "second": {
      "visual": "kn-sub_01.jpg",
      "subtitle_1": "ソルパックに入社して感じている魅力は何ですか？",
      "text_1": "入社後、２ヶ月間の研修を経てすぐに実業務に携わることができていることができます。もちろん分からないことがたくさんありましたが、先輩社員のみなさんがアドバイスしてくれますので、早い段階からスキル向上ができます。まだ、入社してまだ１年弱ですが、一瞬だと思うくらいとても濃密な時間を過ごしています。",
      "subtitle_2": "ソルパックを選んだ理由と入社後感じたギャップは？",
      "text_2": "アットホームな雰囲気が決め手となり最終的にソルパックに入社を決めました。大学時代の友人がソルパックのインターンシップに参加した際、とても明るい環境で先輩方も優しく、楽しく２週間を過ごしたと聞いたのがきっかけでした。 入社後感じるギャップは特にないです。イメージしていた通りでした。事業部を越えても皆さん仲がよく、仕事を終えた後、先輩方に飲みに誘っていただくこともあります。９月に社内でフットサル大会＆BBQのイベントがあり、その際も違う事業部の方とたくさんコミュニケーションをとることができました。いろいろな先輩方の経験談を聞いたりと、とても楽しく過ごしています。",
      "subtitle_3": "学生時代はどんな学生でしたか？",
      "text_3": "思い立ったらすぐ行動する学生でした。出発の前々日に友達から大阪に行こうと言われ、弾丸で大阪旅行など行ったこともありました。何も予定などは立てずに行ったので、宿泊先はスーパー銭湯でした。初めての大阪でしたが、とても楽しかったです。",
      "subtitle_4": "オフタイムは何をしていますか？ or プライベートでの趣味は何ですか？",
      "text_4": "オフタイムはほとんど出掛けています。僕は地方出身なので、一緒に上京している仲間達と集まって飲みに行ったりしています。会社の先輩とサッカー観戦に行くこともあります。ソルパックにはサッカーが好きな方が多く、サッカーの話で盛り上がることが多くとても楽しいです。",
    },
    "formParam": ""
  },
  "interview_sk": {
    "first": {
      "name": "S.Kさん",
      "job": "BPO事業部",
      "year": "2018",
      "title": "旅行業からITへ<br />新たなチャレンジ",
      "visual": "sk-main_01.jpg",
      "subtitle": "スーパーバイザーとしての責任とやりがい",
      "text": "大手不動産会社のお客様のサービスデスク業務のプロジェクト立ち上げ時より、スーパーバイザーとして携わっています。IT業界未経験からのチャレンジで、最初は右も左も分からないような状態でしたが、チーム全体で日々の業務に取り組んでいます。<br>PCの操作方法やOfficeソフトの使い方をはじめとした一般的な問い合わせや、ハードウェアの故障やネットワーク接続不具合などのテクニカルなトラブルシューティングまで、臨機応変に対応しています。<br>チームメンバーからの質問を受け、同時に進んでいく業務も多くありますが、自身の経験をSOLPACでも活かすことができる仕事だと思います。"
    },
    "second": {
      "visual": "sk-sub_01.jpg",
      "subtitle_1": "どんな人と働きたいですか？",
      "text_1": "仲が良いことに越したことはないですが、仕事に関して本気で取り組んでいて、自分の意見・考えをしっかりと持っている人と働きたいです。<br>時には衝突することもあると思いますが、それが本気で仕事をしている証だと思います。<br>（飲みに行く時には違う顔を覗かせる人ってかっこいいですよね。）",
      "subtitle_2": "将来のビジョン、チャレンジしたいことは何ですか？",
      "text_2": "今はサービス系の業務をしていますが、近い将来の目標としてはインフラを学びたいと考えています。<br>遠いビジョンとしてプロジェクト全体を見渡せるような広い視野、知識を持って仕事ができるようになりたいです。",
      "subtitle_3": "オフタイムはどのように過ごしていますか？",
      "text_3": "オフの日はほとんど何かのスポーツをしています。<br>メインは野球、ときどきゴルフ。ロードバイクで遠出することもあります。冬にはスキーもします。",
      "subtitle_4": "",
      "text_4": "",
    },
    "formParam": ""
  },
  "interview_hw": {
    "first": {
      "name": "H.Wさん",
      "job": "BPO事業部",
      "year": "2018",
      "title": "決め手は失敗を恐れず<br />前向きに取り組める環境",
      "visual": "hongou-main.jpg",
      "subtitle": "お客様と直接関わるので<br />モチベーションにつながります",
      "text": "お客様先（グローバルの外資系企業）に常駐し、ヘルプデスク業務に携わっています。業務としては<br />・PCトラブルのサポート<br />・PCやモニターなどのIT機器の管理業務・会議サポート<br />・新規PC購入のサポート<br />などを行っております。<br />何でも屋のような感じがするかもしれませんが、とても重要なお仕事です。<br />トラブルが発生した際には、問題を速やかに把握し、トラブルを解消し、1秒でも業務に支障が出ないように急ぎ対処しています。会議のサポートでは、他拠点とオンラインで結び、かつ大人数の方が参加される重要な会議の為、緊張感を保ちつつ、問題が発生しないように事前に入念な打ち合わせや準備を行い、スムーズな会議の進行とクローズへ導くサポートを入念に行っています。<br />また、普段からお客様と直接関わり合いを持つ機会の多い事もあり、時には感謝のお言葉を頂く事もあり、自身やチームのモチベーションアップに繋がるプラス要素も沢山ありますので、とてもやりがいのある業務です。"
    },
    "second": {
      "visual": "hongou-sub.jpg",
      "subtitle_1": "どんな人と働きたいですか？",
      "text_1": "お客様のためになるサポートを常に心がけ喜んでもらえるよう頑張る業務ですので、<br />相手の立場になって何が最良かの判断が出来、行動に移せる人と一緒に働きたいです。",
      "subtitle_2": "将来のビジョン、チャレンジしたいことは何ですか？",
      "text_2": "英会話ができるようにしたいです。<br />お客様が外資系企業のため海外の方と話す機会があります。<br />その方のご要望にしっかり応えるためにも英会話のスキルを磨きたいです。",
      "subtitle_3": "オフタイムはどのように過ごしていますか？",
      "text_3": "家ではゲームをやっています。ジャンルはFPSやRPGが多いです。<br />天気がいい時は無性に外に出たくなるので、目的もなく外に出て散策しています。<br />友達と予定が合えば、ダーツで遊んだり、飲みにも行っています。",
      "subtitle_4": "",
      "text_4": "",
    },
    "formParam": ""
  }
}


// WEBPACK FOOTER //
// ./src/json/interviews.js